<template>
  <div class="course-container">
    <div class="categroy clearfix">
      <template>
        <dl class="flex-between">
          <dt><i class="wkcourse_icon"></i>学段</dt>
          <dd>
            <a
              href="javascript:;"
              v-for="(v, i) in stageList"
              :key="i"
              :class="{ crt: stageIng.code === v.code }"
              @click="onStaget(v)"
              >{{ v.name }}</a
            >
          </dd>
        </dl>
        <dl class="wktype flex-between">
          <dt><i class="wkcourse_icon"></i>学科</dt>
          <dd>
            <a
              href="javascript:;"
              v-for="(val, key) in subjectList"
              :key="key"
              :class="{ crt: subjectIng.code === val.code }"
              @click="onSubject(val)"
              >{{ val.name }}</a
            >
          </dd>
        </dl>
        <dl class="wktype flex-between">
          <dt><i class="wkcourse_icon"></i>年级</dt>
          <dd>
            <a
              href="javascript:;"
              v-for="(val, key) in gradeList"
              :key="key"
              :class="{ crt: gradeIng.code === val.code }"
              @click="onGrade(val)"
              >{{ val.name }}</a
            >
          </dd>
        </dl>
        <dl class="wktype flex-between">
          <dt><i class="wkcourse_icon"></i>版本</dt>
          <dd>
            <a
              href="javascript:;"
              v-for="(val, key) in versionList"
              :key="key"
              :class="{ crt: versionIng.code === val.code }"
              @click="onVersion(val)"
              >{{ val.name }}</a
            >
          </dd>
        </dl>
        <dl class="wktype flex-between">
          <dt><i class="wkcourse_icon"></i>类型</dt>
          <dd>
            <a
              href="javascript:;"
              v-for="(val, key) in typeList"
              :key="key"
              :class="{ crt: typeIng.code === val.code }"
              @click="onType(val)"
              >{{ val.name }}</a
            >
          </dd>
        </dl>
      </template>
    </div>
    <div class="course">
      <div class="course-tree">
        <el-input
          placeholder="输入关键字进行过滤"
          class="tree-input"
          v-model="filterText"
        >
        </el-input>
        <el-tree
          :data="treeList"
          :props="treeProps"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"
          node-key="id"
          ref="tree"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span :title="node.label" class="tree_title">{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
      <div class="course-list" v-if="isNull">
        <ul class="course-ul">
          <li v-for="(item, index) in courseList" :key="index">
            <a
              :href="`/#/video/${item.video_id}`"
              target="_blank"
              class="inline-block"
            >
              <el-image
                :src="item.ke_images_url"
                class="course-image"
                lazy
              ></el-image>
              <div class="course-info" :title="item.ke_title">
                <div class="course-title">{{ item.ke_title }}</div>
                <div class="course-time">
                  课程时长：{{ item.ke_time_string }}
                </div>
              </div>
            </a>
          </li>
        </ul>
        <div class="clearfix list-page">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.page"
            :page-size="query.page_size"
            :total="pageTotal"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>
      </div>
      <div class="list-container" v-else>
        <div class="column pt50">
          <img src="../../assets/images/list_null.png" alt="" srcset="" />
          <div class="null">暂无数据~~</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "tongBu",
  data() {
    return {
      query: {
        page: 1,
        page_size: 12,
      },
      pageTotal: 0,
      filterText: "",
      treeList: [],
      treeProps: {
        children: "children",
        label: "name",
      },
      courseList: [],
      //知识点分类
      stageList: [],
      subjectList: [],
      typeList: [],
      gradeList: [],
      versionList: [],
      gradeIng: {},
      versionIng: {},
      stageIng: {},
      subjectIng: {},
      typeIng: {},
      isNull: true,
    };
  },
  props: {
    stageSubject: Object,
  },
  created() {
    this.getStageSubjectData();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    getStageSubjectData() {
      this.getRequest("/wenjiaoopne/kc/user/getValidityStageSubject", {
        verify: 1,
        notIn: "1114",
      })
        .then((result) => {
          this.stageList = result.data;
          if (Object.keys(this.stageSubject).length > 0) {
            for (const iterator of this.stageList) {
              if (iterator.code === this.stageSubject.stage.code) {
                this.stageIng = iterator;
                break;
              }
            }
            if (Object.keys(this.stageIng).length > 0) {
              this.subjectList = this.stageIng.children;
            } else {
              this.stageIng = this.stageList[0];
              this.subjectList = this.stageIng.children;
            }
            for (const item of this.subjectList) {
              if (item.code === this.stageSubject.subject.code) {
                this.subjectIng = item;
                break;
              }
            }
            if (Object.keys(this.subjectIng).length <= 0) {
              this.subjectIng = this.subjectList[0];
            }
          } else {
            this.stageIng = this.stageList[0];
            this.subjectList = this.stageIng.children;
            this.subjectIng = this.subjectList[0];
          }
          this.getGradeList(this.stageIng.code, this.subjectIng.code);
        })
        .catch(() => {});
    },

    getGradeList(stageCode, subjectCode) {
      this.getRequest("/wenjiaoopne/kc/zhuan_ti/getZtGradeList", {
        stage_code: stageCode,
        subject_code: subjectCode,
      })
        .then((result) => {
          this.gradeList = result.data.list;
          this.gradeIng = this.gradeList[0];
          this.getVersionList(stageCode, subjectCode, this.gradeIng.code);
        })
        .catch(() => {});
    },

    getVersionList(stageCode, subjectCode, gradeCode) {
      this.getRequest("/wenjiaoopne/kc/zhuan_ti/getZtVersionList", {
        stage_code: stageCode,
        subject_code: subjectCode,
        grade_code: gradeCode,
      })
        .then((result) => {
          this.versionList = result.data.list;
          this.versionIng = this.versionList[0];
          this.getTypeList(
            stageCode,
            subjectCode,
            gradeCode,
            this.versionIng.code
          );
        })
        .catch(() => {});
    },

    getTypeList(stageCode, subjectCode, gradeCode, versionCode) {
      this.getRequest("/wenjiaoopne/kc/zhuan_ti/getZtList", {
        stage_code: stageCode,
        subject_code: subjectCode,
        grade_code: gradeCode,
        version_code: versionCode,
      })
        .then((result) => {
          this.typeList = result.data.list;
          this.typeIng = {
            code: this.typeList[0].code,
            name: this.typeList[0].name,
          };
          this.treeList = this.typeList[0].children;
          this.treeCode = this.typeIng.code;
          this.getCourseList(stageCode, subjectCode, this.treeCode);
        })
        .catch(() => {});
    },

    getCourseList(stageCode, subjectCode, treeCode) {
      this.getRequest(
        "/wenjiaoopne/kc/zhuan_ti/getZtCourseList",
        Object.assign(this.query, {
          tree_code: treeCode,
          stage_code: stageCode,
          subject_code: subjectCode,
        })
      )
        .then((result) => {
          this.courseList = result.data.list;
          this.pageTotal = result.data.total_count || 0;
          this.isNull = this.courseList.length > 0;
          this.isClick = false;
        })
        .catch(() => {});
    },
    //点击知识点学段
    onStaget(item) {
      this.stageIng = item;
      this.subjectList = this.stageIng.children;
      this.typeList = [];
      this.treeList = [];
      this.courseList = [];
      this.pageTotal = 0;
      this.subjectIng = this.subjectList[0];
      this.$set(this.query, "page", 1);
      this.getGradeList(this.stageIng.code, this.subjectIng.code);
      this.$emit("stagetSubjectCallBack", {
        stage: this.stageIng,
        subject: this.subjectIng,
      });
    },
    // 选择知识点学科
    onSubject(item) {
      this.subjectIng = item;
      this.typeList = [];
      this.treeList = [];
      this.treeIng = {};
      this.courseList = [];
      this.pageTotal = 0;
      this.$set(this.query, "page", 1);
      this.getGradeList(this.stageIng.code, this.subjectIng.code);
      this.$emit("stagetSubjectCallBack", {
        stage: this.stageIng,
        subject: this.subjectIng,
      });
    },
    onGrade(item) {
      this.gradeIng = item;
      this.treeList = [];
      this.typeList = [];
      this.courseList = [];
      this.pageTotal = 0;
      this.$set(this.query, "page", 1);
      this.getVersionList(
        this.stageIng.code,
        this.subjectIng.code,
        this.gradeIng.code
      );
    },
    onVersion(item) {
      this.versionIng = item;
      this.treeList = [];
      this.courseList = [];
      this.pageTotal = 0;
      this.$set(this.query, "page", 1);
      this.getTypeList(
        this.stageIng.code,
        this.subjectIng.code,
        this.gradeIng.code,
        this.versionIng.code
      );
    },
    onType(item) {
      this.treeList = [];
      this.treeIng = {};
      this.pageTotal = 0;
      this.courseList = [];
      this.typeIng = item;
      this.treeList = this.typeIng.children;
      this.treeCode = this.typeIng.code;
      this.getCourseList(this.stageIng.code, this.subjectIng.code, this.treeCode);
      this.$set(this.query, "page", 1);
    },
    onSelectCourse(vid) {
      this.$router.push({ path: `/video/${vid}` });
    },

    // 点击树状处理事件
    handleNodeClick(data) {
      this.$set(this.query, "page", 1);
      this.treeCode = data.code;
      this.getCourseList(this.stageIng.code, this.subjectIng.code, this.treeCode);
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    handlePageChange(v) {
      this.$set(this.query, "page", v);
      this.getCourseList(this.stageIng.code, this.subjectIng.code, this.treeCode);
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>
<style scoped>
.course-container {
  width: 1195px;
  margin: 0 auto;
  height: 100%;
}
.course-container .categroy {
  width: 100%;
  /* height: 180px; */
  background-color: #ffffff;
}
.course-container .categroy dl {
  margin: 0px 20px;
  height: 34px;
  padding: 13px 0px;
}
.course-container .categroy dl dt {
  width: 72px;
  float: left;
  color: #4f4e4e;
  font-size: 16px;
  line-height: 34px;
  border-right: 1px solid #dddddd;
}
.course-container .categroy dl dt i.wkcourse_icon {
  width: 14px;
  height: 19px;
  display: block;
  background: url(https://wk.canpoint.net/Template/style1/style_img/wkcourse_icon.png)
    0px 0px;
  float: left;
  margin: 8px 10px 0px 0px;
}
.course-container .categroy dl.wktype {
  border-top: 1px solid #dddddd;
}
.course-container .categroy dl.wktype dt i.wkcourse_icon {
  background-position: 0px -25px;
  margin-top: 10px;
}
.course-container .categroy dl dd {
  width: 1067px;
  margin-top: 2px;
  margin-left: 15px;
}
.course-container .categroy dl dd a {
  float: left;
  line-height: 26px;
  color: #4f4f4f;
  font-size: 14px;
  text-align: center;
  padding: 2px 20px;
}
.course-container .categroy dl dd a.crt {
  background-color: #02a4ef;
  color: #fff;
}
.course-container .course_lst {
  width: 100%;
}
.list-container {
  margin-left: 290px;
  height: 640px;
}
.course-container .course_lst ul li {
  height: 265px;
  overflow: hidden;
  background-color: #ffffff;
  margin-top: 20px;
  position: relative;
}
.course-container .course_lst ul li .meal_icon {
  position: absolute;
  width: 80px;
  height: 80px;
  display: inline-block;
  background: url(https://wk.canpoint.net/Template/style1/style_img/wkcourse_icon.png)
    no-repeat;
  left: 0;
  top: 0;
}
.course-container .course_lst ul li .wkcourse_icon {
  width: 78px;
  height: 78px;
  background: url(https://wk.canpoint.net/Template/style1/style_img/wkcourse_icon.png) -30px
    0px;
  display: block;
  position: absolute;
  top: 0px;
  right: 0px;
}
.course-container .course_lst ul li a.wkcourse_img {
  width: 452px;
  height: inherit;
  display: block;
  float: left;
  position: relative;
}
.course-container .course_lst ul li a.wkcourse_img .free {
  position: absolute;
  top: 0;
  right: 0;
  width: 120px;
  line-height: 48px;
  background: #f56d03;
  font-size: 20px;
  color: #fff;
  text-align: center;
  box-shadow: -4px 4px 6px rgba(0, 0, 0, 0.25);
}
.course-container .course_lst ul li .wkcourse_ct_m {
  width: 475px;
  padding-left: 30px;
  float: left;
  overflow: hidden;
  height: 100%;
}
.course-container .course {
  position: relative;
  width: 100%;
  margin-top: 10px;
}
.course-container .course .course-tree {
  position: absolute;
  top: 0;
  left: 0;
  width: 250px;
  padding: 0 20px;
  height: 640px;
  overflow-y: auto;
  background-color: #fff;
}
.el-tree {
  margin-top: 10px;
}
.tree-input {
  margin-top: 20px;
}
.course-list {
  margin-left: 290px;
  height: 100%;
  /* background-color: #fff; */
}
.course-ul {
  min-height: 612px;
}
.course-ul li {
  float: left;
  width: 216px;
  background-color: #ffffff;
  cursor: pointer;
  margin: 0 0px 15px 10px;
}
.course-ul li:hover {
  box-shadow: 0px 1px 10px #b2bcc2;
}
.course-image {
  /* width: 100%; */
  width: 216px;
  height: 122px;
}
.course-info {
  margin: 10px;
}
.course-info div:first-child {
  width: 192px;
  margin-bottom: 5px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.course-time {
  color: #929db3;
}
.list-page {
  width: 100%;
  text-align: right;
  padding-bottom: 10px;
}
.course-title {
  color: #4f4f4f;
}
</style>
